module.exports = __webpack_public_path__ + "img/user-circle.fad234d3.svg";